const LessonEventsFromEnum = {
  UI: 'UI',
  Keyboard: 'KEYBOARD',
  System: 'SYSTEM'
};

export { LessonEventsFromEnum };
export default LessonEventsFromEnum;
